import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  UPDATE_SELECTED_ITEMS,
  UPDATE_SELECTED_PRODUCTS,
  UPDATE_SELECTED_PRODUCT,
  SEARCH_PRODUCT_SKU_REQUESTED,
  SEARCH_PRODUCT_SKU_SUCCESS,
  SEARCH_PRODUCT_SKU_FAILURE,
  DOWNLOAD_PREVIEW_REQUESTED,
  DOWNLOAD_PREVIEW_SUCCESS,
  DOWNLOAD_PREVIEW_FAILURE,
  FIND_BARCODE_IMAGE_REQUESTED,
  FIND_BARCODE_IMAGE_SUCCESS,
  SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED,
  SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS,
  SEARCH_PRODUCT_BARCODE_VALUE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  searchedBrands: {},
  searchedProducts: null,
  searchedBarcodes: [],
  searchingBarcodes: [],
  searchEndCursor: null,
  searchStartCursor: null,
  searchHasNextPage: null,
  searchHasPreviousPage: null,
  missingBarcodes: [],
  activeBarcode: null,
  sessionProductActions: [],
  batchProductActions: [],
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  printable: 'false',
  selectedVariantList: [],
  productSelections: {},
  downloadUrl: null,
  errors: null
};

const products = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SEARCH_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedProducts: null,
        searchedBarcodes: [],
        searchingBarcodes: [],
        missingBarcodes: [],
        searchEndCursor: null,
        searchStartCursor: null,
        searchHasNextPage: null,
        searchHasPreviousPage: null,
      });

    case SEARCH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        searchedBrands: action.payload.brands,
        searchedProducts: action.payload.products,
        // searchedBarcodes: action.payload.barcodes,
        searchEndCursor: action.payload.page_info.endCursor,
        searchStartCursor: action.payload.page_info.startCursor,
        searchHasNextPage: action.payload.page_info.hasNextPage,
        searchHasPreviousPage: action.payload.page_info.hasPreviousPage,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SEARCH_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case UPDATE_SELECTED_ITEMS:
      return Object.assign({}, state, {
        selectedVariantList: action.payload
      });

    case UPDATE_SELECTED_PRODUCTS:
      return Object.assign({}, state, {
        productSelections: action.payload
      });

    case SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedProducts: null
      });

    case SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS:
      return Object.assign({}, state, {
        activeBarcode: action.payload.products,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SEARCH_PRODUCT_BARCODE_VALUE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case UPDATE_SELECTED_PRODUCT:
      let idList = state.selectedVariantList.map((variant) => variant.id);

      let unselectedVariants = action.payload.variants.filter(variant => !idList.includes(variant.id));
      let selectedVariants = action.payload.variants.filter(variant => idList.includes(variant.id));

      if(unselectedVariants.length === 0) {
        newState.productSelections[action.payload.id] = true;
      } else if(selectedVariants.length === 0) {
        newState.productSelections[action.payload.id] = false;
      } else {
        newState.productSelections[action.payload.id] = 'indeterminate';
      }

      return newState;

    case SEARCH_PRODUCT_SKU_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedProducts: null,
      });

    case SEARCH_PRODUCT_SKU_SUCCESS:
      return Object.assign({}, state, {
        activeBarcode: action.payload.sku_item_data,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SEARCH_PRODUCT_SKU_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case DOWNLOAD_PREVIEW_REQUESTED:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'requesting_preview',
        downloadUrl: null,
      });

    case DOWNLOAD_PREVIEW_SUCCESS:
      return Object.assign({}, state, {
        downloadUrl: action.payload.preview_url,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case DOWNLOAD_PREVIEW_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case FIND_BARCODE_IMAGE_REQUESTED:
      return Object.assign({}, state, {
        searchingBarcodes: [...state.searchingBarcodes, action.payload]
      });

    case FIND_BARCODE_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        searchingBarcodes: state.searchingBarcodes.filter(item => item !== action.payload.found_barcode_symbol && item !== action.payload.missing_barcode_symbol),
        searchedBarcodes: [...state.searchedBarcodes, action.payload.found_barcode_symbol].filter(item => item),
        missingBarcodes: [...state.missingBarcodes, action.payload.missing_barcode_symbol].filter(item => item)
      });

    default:
      return state;
  }
}

export default products;
